console.log('CUSTOM JS UPDATED');

document.addEventListener('click', function(e) {
  const row = e.target.closest('tr');
  if (!row) return;

  const match = (row.innerText || '').match(/D\d+/);
  if (!match) return;

  const code = match[0];

  const galleryImg = Array.from(document.querySelectorAll('.product__media img'))
    .find(img => img.src.includes('/' + code + '.jpg'));

  if (!galleryImg) {
    console.log('No image found for', code);
    return;
  }

  console.log('Found image for', code);

  const mediaItem = galleryImg.closest('.product__media-item');
  const mediaButton = mediaItem ? mediaItem.querySelector('button, a') : null;

  if (mediaButton) {
    mediaButton.click();
  } else {
    galleryImg.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}, true);